import * as Yup from "yup";
import {
  TextField,
  SelectField,
  CheckListField,
} from "../../../../common/forms";
import {
  getDocumentOptions,
  getEnvironmentOptions,
  getProviderOptions,
} from "./KYC.options";

export function formSchema() {
  return Yup.object().shape({
    clientId: Yup.string().when("provider", {
      is: "MITEK",
      then: (schema) => schema.required("clientId is required"),
      otherwise: (schema) => schema,
    }),
    secret: Yup.string().when("provider", {
      is: "MITEK",
      then: (schema) => schema.required("secret is required"),
      otherwise: (schema) => schema,
    }),
    apiVersion: Yup.string().when("provider", {
      is: "MITEK",
      then: (schema) => schema.required("apiVersion is required"),
      otherwise: (schema) => schema,
    }),
    environment: Yup.string().when("provider", {
      is: "MITEK",
      then: (schema) => schema.required("environment is required"),
      otherwise: (schema) => schema,
    }),
    redirectUri: Yup.string().when("provider", {
      is: "MITEK",
      then: (schema) => schema.required("redirectUri is required"),
      otherwise: (schema) => schema,
    }),
    baseUrl: Yup.string().when("provider", {
      is: "MITEK",
      then: (schema) => schema.required("baseUrl is required"),
      otherwise: (schema) => schema,
    }),
  });
}

export function formFields({ disabled, values }) {
  return [
    {
      size: 12,
      field: (
        <SelectField
          id="provider"
          label="Provider"
          disabled={disabled}
          options={getProviderOptions()}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="clientId"
          label="clientId"
          type="text"
          disabled={disabled}
          required={values?.provider === "MITEK"}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="secret"
          label="secret"
          type="text"
          disabled={disabled}
          required={values?.provider === "MITEK"}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="apiVersion"
          label="apiVersion"
          type="text"
          disabled={disabled}
          required={values?.provider === "MITEK"}
        />
      ),
    },
    {
      size: 12,
      field: (
        <SelectField
          id="environment"
          label="Environment"
          options={getEnvironmentOptions()}
          disabled={disabled}
          required={values?.provider === "MITEK"}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="baseUrl"
          label="baseUrl"
          type="text"
          disabled={disabled}
          required={values?.provider === "MITEK"}
        />
      ),
    },
    {
      size: 12,
      field: (
        <TextField
          id="redirectUri"
          label="redirectUri"
          type="text"
          disabled={disabled}
          required={values?.provider === "MITEK"}
        />
      ),
    },
    {
      size: 6,
      field: (
        <CheckListField
          id="mandatory"
          label="mandatory"
          options={getDocumentOptions()}
          disabled={disabled}
          required={values?.provider === "MITEK"}
        />
      ),
    },
  ];
}
